import { render, staticRenderFns } from "./RegistrationConfirmEmail.vue?vue&type=template&id=78515722&scoped=true&"
import script from "./RegistrationConfirmEmail.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirmEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78515722",
  null
  
)

export default component.exports